import { Children } from 'react';
import styled from 'styled-components';
import { GRID_BREAKPOINT_EXTRA_LARGE } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRow = styled.div.withConfig({
  displayName: "Row__StyledRow",
  componentId: "sc-1ayfxb6-0"
})(["@media (max-width:", "){flex-direction:column;}"], GRID_BREAKPOINT_EXTRA_LARGE);
const StyledChild = styled.div.withConfig({
  displayName: "Row__StyledChild",
  componentId: "sc-1ayfxb6-1"
})(["width:", "%;@media (max-width:", "){width:100%;}"], props => 100 / props.childCount - 2, GRID_BREAKPOINT_EXTRA_LARGE);
function Row(props) {
  const {
    align,
    children,
    justify
  } = props;
  const childCount = Children.count(children);
  return /*#__PURE__*/_jsx(StyledRow, {
    className: `align-${align} justify-${justify}`,
    children: Children.map(children, child => /*#__PURE__*/_jsx(StyledChild, {
      childCount: childCount,
      children: child
    }))
  });
}
Row.defaultProps = {
  align: 'center',
  justify: 'between'
};
export default Row;